import { Button } from "@ubnt/store.core/lib/components/Button";
import { StyleableSvgImage } from "@ubnt/store.core/lib/components/StyleableSvgImage";
import { BREAKPOINTS } from "@ubnt/store.core/lib/constants/layout";
import styled, { css } from "styled-components";

export const WrapContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const Wrap = styled.div`
  aspect-ratio: 1920/880;
  box-shadow: inset 0 0 0 1000px rgba(0, 0, 0, 0.6);
  max-height: 880px;
  max-width: 3840px;
  min-height: 640px;
  padding: 245px 0;
  width: 100%;
  position: relative;

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    padding: 24px 0 43%;
    min-height: 480px;
  }
`;

export const StyledVideo = styled.video`
  height: 100%;
  left: 0;
  max-height: 880px;
  object-fit: cover;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: -1;
`;

export const StyledVideoBg = styled.video`
  height: 100%;
  left: 0;
  maxheight: 880px;
  object-fit: cover;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: -1;
`;

export const InnerWrap = styled.div`
  max-width: 410px;
  color: ${({ theme }) => theme.colors.neutral00};

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    display: flex;
    flex-direction: column;
  }
`;

export const Title = styled.h2`
  font-size: 30px;
  font-weight: 700;
  line-height: normal;

  margin: 0 0 6px;

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    font-size: 26px;
    line-height: normal;
    text-align: center;
    text-wrap: balance;
  }
`;

export const Subtitle = styled.p`
  color: ${({ theme }) => theme.colors.neutral04};
  font-size: 20px;
  font-weight: 400;
  line-height: 26px;

  margin: 0 0 54px;

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    font-size: 16px;
    line-height: 19.33px;
    text-align: center;

    margin-bottom: 18px;

    text-wrap: balance;
  }
`;

export const LogoWrap = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: nowrap;

  align-items: center;

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    justify-content: center;

    margin-bottom: 18px;
  }

  @media (max-width: 365px) {
    flex-direction: column;
    gap: 10px;
  }
`;

export const PlayIcon = styled(StyleableSvgImage)`
  color: ${({ theme }) => theme.colors.neutral00};

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    height: 12px;
  }
`;

export const Logo = styled.img`
  flex-shrink: 1;
`;

export const And = styled.span`
  height: 47.1px;
  width: 1px;
  background-color: rgba(255, 255, 255, 0.7);
  flex-shrink: 0;
`;

export const WatchVideoButton = styled(Button)<{ $isAlignLeft?: boolean }>`
  padding: 10px 15px;
  margin: 0 auto;
  background: rgba(255, 255, 255, 0.1);

  ${({ $isAlignLeft }) =>
    $isAlignLeft &&
    css`
      margin: 0;
      position: static !important;
      margin-top: 44px;
    `}

  &&,
  &&:hover {
    color: ${({ theme }) => theme.colors.neutral00};
    border-color: ${({ theme }) => theme.colors.neutral00};
  }

  &&:hover {
    background-color: ${({ theme }) => theme.colors.neutral02};
  }

  > div {
    display: flex;
    align-items: center;
    gap: 8px;

    font-weight: bold;
  }

  @media ${BREAKPOINTS.MOBILE_UP} {
    position: absolute;
    right: 0;
    left: 0;
    bottom: 90px;

    max-width: max-content;
    padding: 14px 15px;

    font-size: 18px;
    line-height: 20px;
  }
`;
